import React from 'react'
import QRCode from 'react-qr-code'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { appBaseUrl } from '../../../utils/appBaseUrl'
import useTranslation from '../../../utils/translation'

const QrContainer = styled.div`
  padding: 30px;
  text-align: center;
`
const QrCodeWrapper = styled.div`
  background-color: #ffffff;
  padding: 10px;
  display: inline-block;
  border-radius: 3px;
`
const QrHeading = styled.h5`
  font-size: 14px;
  font-weight: 500;
  margin-block-start: 0em;
  margin-block-end: 0em;
  line-height: 18px;
  padding-bottom: 12px;
`
const QrParagraph = styled.p`
  font-size: 14px;
  font-weight: 400;
  margin-block-start: 0em;
  margin-block-end: 0em;
  line-height: 18px;
  padding-bottom: 12px;
`

const QRUpload = ({ qrBlockId }) => {
  const t = useTranslation('app.prep-form')
  const location = useLocation()
  const appointmentId = new URLSearchParams(location.search).get('appointment')
  const qrBlockValue = `${appBaseUrl}?appointment=${appointmentId}&block-focus=${qrBlockId}`

  return (
    <QrContainer>
      <QrHeading>{t('upload-from-phone')}</QrHeading>
      <QrParagraph>{t('scan-qr-code')}</QrParagraph>
      <QrCodeWrapper>
        <QRCode value={qrBlockValue} size={100} />
      </QrCodeWrapper>
    </QrContainer>
  )
}

export default QRUpload
